
<template> 
    <CardRh titulo="Etapa 2/4 - Disciplinas"  v-if="completo">  
        <div class="row">  
            <div class="col-12 col-sm-12 col-lg-12" v-if="turma">  
                <div class="form-group" v-if="disciplinas != null"> 
                    <label  >{{turma.turma.descricao}}:</label>  
                    <Multiselect  :options="disciplina_select" :searchable="true"  @change="selecionouDisciplina" @clear="limpouDisciplina"></Multiselect>    
                </div>  
            </div>   
        </div>  
        <br>
        <div>
            <button   class="btn btn-warning float-left" @click="prevPage( )">
                <i class=" fa fa-angle-left "></i> <span v-html="'&nbsp'"></span> Voltar
            </button>
            <button class="btn btn-success float-right" @click="nextPage( )">
                Próxima <span v-html="'&nbsp'"></span> <i class=" fa fa-angle-right "></i>
            </button>
        </div> 
    </CardRh>   
</template>

<script lang="ts"> 
 
    import CardRh from   "@/components/cards/ManzaCard.vue" 
    import { Options , Vue  } from "vue-class-component";  
    import {  Prop } from 'vue-property-decorator';     
    import Multiselect from '@vueform/multiselect'
    import SiteUtils from "@/assets/ts/aplicacao/site";
    import DisciplinaService from   "@/service/v1/sigap/DisciplinaService"  
    
    @Options({
        name: "ControladorEtapa2",
        components: {  CardRh , Multiselect },   
    }) 
    export default class ControladorEtapa2 extends Vue {
          
        @Prop( ) readonly service!: any 
        @Prop( ) readonly turmas_que_controlo!: any 
        @Prop( ) readonly formData!: any 
        
        public  completo: any =  false ;  
        public  pelotao: any =  null ;  
        public  turma: any =  null ;    
        public  aula: any = null ;  
        public  disciplinas: any =   null ;  
        public  disciplinaService =  new DisciplinaService() ;  
         
        created() {
            if (!this.turmas_que_controlo) { 
                this.prevPage( );
            } 
        }
         
        activated(){ 
            if (!this.turmas_que_controlo || !this.formData.data || !this.formData.inicio || !this.formData.fim ) { 
                this.prevPage( );
            }
            const turmas = this.turmas_que_controlo.filter( opt => {if(opt.matriculaId){return true;}});
            if(turmas.length > 1 ){
                SiteUtils.toastErro('Você possui mais de uma turma: ' ,  'entre em contato com a administração para remover a antiga.'  );
                this.prevPage( ); 
                return;
            }
            if( !turmas || turmas.length < 1 ){
                SiteUtils.toastErro('Nenhuma turma disponível' ,  ''  );
                this.prevPage( ); 
                return;
            }  
            this.turma = turmas[0];

            this.getDisciplinas( this.turma.turmaId);
 
            this.pelotao = this.turma.pelotao; 
            this.completo = true; 
        }
         
        public nextPage() {
            this.$emit('nextPage', {
                formData: { 
                    aula: this.aula, 
                    turma: this.turma, 
                },
                pageIndex: 1
            });
        }

        prevPage() {
            this.$emit('prevPage', {
                pageIndex: 1
            });
        }
        
        get disciplina_select(){
            if(this.disciplinas){ 
                return this.disciplinas.map((item) => { return { value:  {disciplinaId:item.id, descricao: item.descricao } , label: item.descricao } });   
            }
            return null;
        }
   
        public getDisciplinas( turmaId: any ) {
            this.disciplinaService.getAll(`skip=0&take=100&turmaId=${turmaId}`).then( response =>{ 
                this.disciplinas = response.data;
            });  
        }
 
        public selecionouDisciplina(event){ 
            if(event){
                this.aula = event;
                //  [{
                //     'disciplina_nome': event.disciplina,
                //     'disciplinaId': event.disciplinaId,
                //     'pelotao': this.pelotao,
                //     'turma': event.turmaId,
                //     'matriculaId': event.matriculaId,
                //     'turma_nome': event.turma 
                // }];
            }
        }

        public limpouDisciplina(event){ 
            this.aula = null;
        }
 
    } 
</script>

<style scoped>  
    .float-left{
        float: left !important;
    } 
    .float-right{
        float: right;
    } 
    .col-12{
        margin-bottom: 40px;
    } 
</style> 